import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, type JSX } from "react";
import { z } from "zod";
import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import type { FragmentType } from "@repo/graphql-types/fragment-masking";
import { useGraphQL } from "@/hooks/use-graphql";
import {
  SendPaymentForm,
  type SendPaymentFormFragment,
} from "@/components/payment/forms/send-payment-form";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { RecipientEmptyStateWrapper } from "@/components/payment/bank/account/recipient-empty-state";

const SendPaymentPageQuery = graphql(/* GraphQL */ `
  query SendPaymentPageQuery($codAgendamento: Int!) {
    agendamento: agendamentos_by_pk(codAgendamento: $codAgendamento) {
      pago
      ...SendPaymentFormFragment
    }
  }
`);

const SendPaymentPage = (): JSX.Element => {
  const router = useRouter();
  const { codAgendamento } = Route.useParams();

  const queryResult = useGraphQL(SendPaymentPageQuery, {
    codAgendamento,
  });
  const { data } = queryResult;

  useEffect(() => {
    if ((data && !data.agendamento) ?? data?.agendamento?.pago) {
      void router.navigate({ to: "/waiting-room" });
    }
  }, [data, router]);

  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Enviar pagamento" align="center" />
      </HeaderRoot>
      <Page>
        <RecipientEmptyStateWrapper>
          <AsyncDataWrapper {...queryResult}>
            {data ? (
              <SendPaymentForm
                data={data.agendamento as FragmentType<typeof SendPaymentFormFragment>}
              />
            ) : null}
          </AsyncDataWrapper>
        </RecipientEmptyStateWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/waiting-room/$codAgendamento/send-totem-payment/")(
  {
    component: SendPaymentPage,
    parseParams: (params) => ({
      codAgendamento: z.int().parse(Number(params.codAgendamento)),
    }),
  },
);
